import React from "react";
import { PDFExport } from '@progress/kendo-react-pdf';
import { Navigate, useParams } from 'react-router-dom';
import { useRef } from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';
import Moment from 'react-moment';
const GLOBAL = require('../../commonConstants.js');
const participants = GLOBAL.BASE_URL+"getparticipantOrderId/";
const course = GLOBAL.BASE_URL+"purchase-course";
const url1 = GLOBAL.BASE_URL+"contactUS";

function ProformaInVoice() {
  const cookies = new Cookies();
  const { id: orderId } = useParams();
  const savedOrderData = cookies.get('data');
  const [participantData, setParticipantData] = React.useState(savedOrderData || null);
  const [isParticipantLoading, setIsParticipantLoading] = React.useState(!!orderId && !savedOrderData);
  const [invoiceError, setInvoiceError] = React.useState(null);

  const [getCourse, setCourse] = React.useState(null);
  const [getContactData, setContactData] = React.useState(null);

  React.useEffect(() => {
    if (!orderId) return;
    setIsParticipantLoading(true);
    axios.get(participants + orderId).then((response) => {
      if (response.data && response.data.order_id) {
        setParticipantData(response.data);
        cookies.set('data', response.data, { path: '/' });
      } else {
        setInvoiceError('Order details not found for this Order ID.');
      }
    }).catch(() => {
      setInvoiceError('Unable to load order details right now. Please refresh and try again.');
    }).finally(() => {
      setIsParticipantLoading(false);
    });
  }, [orderId]);

  const myArray = participantData || {};

  var selectedCourse = myArray.selected_course;
  var filter = Array.isArray(selectedCourse)
    ? selectedCourse.map(String)
    : (typeof selectedCourse === 'string'
        ? selectedCourse.split(',').map((item) => item.trim())
        : []);
  if(getCourse){
        var users= getCourse.filter(item => {
          for (let key in filter) {
            if ( String(item.id) === String(filter[key]))
              return item;
          }
        });
      var sum = users.reduce(function(prev, current) {
        return prev + +current.fee
      }, 0);
      }

  var discountAmount = myArray.discount_amount ? Number(myArray.discount_amount) : 0;
  var savedPayAmount = myArray.pay_amount ? Number(myArray.pay_amount) : null;


      function percentage(num, per){
        return (num/100)*per;
    }
    function sum_value(num, per){
        var total_amount = sum + percentage(num,18);
        return total_amount;
    }

    var total_amount = savedPayAmount !== null ? savedPayAmount : sum_value(sum, 18);
    var gstAmount = sum + percentage(sum, 18) - sum - discountAmount;
    React.useEffect(() => {
    axios.get(course).then((response) => {
    setCourse(response.data);
     }).catch(() => {
      setInvoiceError('Unable to load course details right now. Please refresh and try again.');
     });
    axios.get(url1).then((response) => {
    setContactData(response.data);
     }).catch(() => {
      setContactData([]);
     });
   },[]);

  const contactInfo = (Array.isArray(getContactData) && getContactData.length > 0)
    ? getContactData[0]
    : {
        india_smart_grid_forum: 'India Smart Grid Forum, CBIP Building, Malcha Marg, Chanakyapuri, New Delhi - 110021',
        phone: '+91 114103 0398',
        email: 'contactus@indiasmartgrid.org',
        website: 'https://indiasmartgrid.org',
      };

  const pdfExportComponent = useRef(null);
  const  handleExportWithComponent  = (event) => {
    pdfExportComponent.current.save();
}
  if (!participantData && !orderId) return <Navigate to="/" replace />;
  if (invoiceError) {
    return (
      <section className="space-page trainings-participants">
        <div className="container">
          <div className="alert alert-danger" role="alert">{invoiceError}</div>
        </div>
      </section>
    );
  }
  if (!participantData && orderId && isParticipantLoading) {
    return (
      <section className="space-page trainings-participants">
        <div className="container">
          <div className="alert alert-info" role="alert">Loading your payment confirmation...</div>
        </div>
      </section>
    );
  }
  if (!getCourse) {
    return (
      <section className="space-page trainings-participants">
        <div className="container">
          <div className="alert alert-info" role="alert">Preparing your invoice details...</div>
        </div>
      </section>
    );
  }

  return (
    <>
  <PDFExport ref={pdfExportComponent} paperSize="auto" margin="8mm">
      <section className="proforma-in-voice">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <img
                src={`${process.env.PUBLIC_URL}/images/isgf_Logo.png`}
                alt=""
                className="isgf-logo"
              />
              <div className="address">
                <p>
                 {contactInfo.india_smart_grid_forum} <br />
                  T: {contactInfo.phone} <br />
                  E-mail:{" "}
                  <a href="mailto:contactus@indiasmartgrid.org">
                    {" "}
                    {contactInfo.email}
                  </a>{" "}
                  <br />
                  Website:{" "}
                  <a href={contactInfo.website}>
                    {contactInfo.website}
                  </a>{" "}
                </p>
              </div>
              <h3 className="mb-4">PROFORMA INVOICE (QUOTATION ONLY)</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">


              <p>
                <b>Name:</b> {myArray.name ? myArray.name : ''}
              </p>
              <p>
                <b>Company:</b> {myArray.company ? myArray.company : ''}
              </p>
              <p>
                <b>Address:</b> {myArray.address ? myArray.address : ''}
              </p>
              <p>
                <b>State:</b> {myArray.state ? myArray.state : ''}
              </p>
              <p>
                <b>Country:</b> {myArray.country ? myArray.country : ''}
              </p>
              <p>
                <b>GST:</b> {myArray.gst ? myArray.gst : ''}
              </p>
              <p>
                <b>Date:</b> <Moment format="DD MMMM YYYY H:mm">
                            </Moment>
              </p>
            </div>
          </div>
          <p>
            We are pleased to quote the Program Fee for following Online
            Training Programs:
          </p>
          <table className="table table-bordered invoice-items">
            <colgroup>
              <col className="invoice-column-number" />
              <col className="invoice-column-date" />
              <col className="invoice-column-model" />
              <col className="invoice-column-program" />
              <col className="invoice-column-fee" />
              <col className="invoice-column-gst" />
              <col className="invoice-column-total" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Date</th>
                <th scope="col">Model(Online/Offline)</th>
                <th scope="col">Program</th>
                <th scope="col">Fee</th>
                <th scope="col">GST</th>
                <th scope="col">Total</th>
              </tr>
            </thead>
            <tbody>
              {(users) && users.map((data,index)=>(
              <tr>
                <td>{index+1}</td>
                <td>{data.date}
                </td>
                <td>{data.model}</td>
                <td>{data.program} </td>
                <td>Rs. {Number(data.fee).toFixed(2)}</td>
                <td>18%</td>
                <td>Rs. {Number(sum_value((data.fee),18)).toFixed(2)}</td>

              </tr>
              ))}

            </tbody>
          </table>
          <table className="table table-bordered invoice-totals">
            <tbody>
              <tr>
                <td><b>Sub-Total</b></td>
                <td>Rs. {Number(sum).toFixed(2)}</td>
              </tr>
              <tr>
                <td><b>Discount</b></td>
                <td>Rs. {Number(discountAmount).toFixed(2)}</td>
              </tr>
              <tr>
                <td><b>GST</b></td>
                <td>18%</td>
              </tr>
              <tr className="invoice-total-row">
                <td><b>Total</b></td>
                <td><b>Rs. {Number(total_amount).toFixed(2)}</b></td>
              </tr>
            </tbody>
          </table>
          <p>**** This is an Autogenerated Proforma Invoice so signature is not required</p>
        </div>

      </section>
      </PDFExport>
      <div className="text-center mt-2 mb-5">
        <button className="btn btn-secondary print-btn"  primary={true} onClick={handleExportWithComponent}>Download</button>
        </div>
    </>
  );
}

export default ProformaInVoice;
